module.exports = __webpack_public_path__ + "static/media/rightarrow.ea30ee72.svg";